export default __webpack_public_path__ + "static/media/ctst-logo.af05c95a.png";